import { getRefundList } from '@/api';
import ReceiptLayout from '@/components/Receipt/ReceiptLayout';
import UploadItem from '@/components/UploadImage/UploadItem';
import { useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import {
  IGetRefundListPayload,
  IGetRefundListResponse,
} from '@/types/common.type';
import { IMG_RECEIPT_CASE_2 } from '@repo/assets';
import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import styled from 'styled-components';

const TITLE = {
  KOR: {
    title: '환급 영수증을 업로드하세요',
    subTitle: '아래 예시와 같이 출력된 영수증에 세관 도장을 받으세요.',
  },
  ENG: {
    title: 'Upload Refund Receipt',
    subTitle: 'Get the printed receipt stamped by customs as shown below.',
  },
};

const UploadReceipt = () => {
  const { passportNumber, nationality } = useAppSelector(
    (state) => state,
  ) as IGlobalState;
  const [data, setData] = useState<IGetRefundListResponse>([]);
  const LANG = nationality === 'KOR' ? 'KOR' : 'ENG';

  const getRefundListMutation = useMutation<
    IGetRefundListResponse,
    AxiosError,
    IGetRefundListPayload
  >((payload) => getRefundList(payload), {
    retry: false,
    onSuccess: (list) => {
      setData(list);
    },
    onError: () => {
      alert(`[error code:0000 ]서버요청에 실패하였습니다. 다시 시도해주세요.`);
    },
  });

  useEffect(() => {
    getRefundListMutation.mutate({
      passportNumber,
      refundAfter: true,
      latest: true,
    });
  }, []);

  return (
    <ReceiptLayout hasPadding={false}>
      <TitleWrapper>
        <Title>{TITLE[LANG].title}</Title>
        <SubTitle>{TITLE[LANG].subTitle}</SubTitle>
        <img src={IMG_RECEIPT_CASE_2} alt='' width={'100%'} />
      </TitleWrapper>
      <DevideLine />
      <ReceiptWrapper>
        {data?.map((item, idx) => (
          <li key={idx}>
            <UploadItem {...item} refetchHome={() => {}} isBorder />
          </li>
        ))}
      </ReceiptWrapper>
    </ReceiptLayout>
  );
};

export default UploadReceipt;

const TitleWrapper = styled.div`
  padding: 0 20px;
`;

const Title = styled.strong`
  width: 100%;
  margin: 12px 0 6px;
  color: var(--KTP-Grayscale-80, var(--KTP-Color-Mono-80, #3a3b3e));
  font-size: 24px;
  font-weight: 700;
  line-height: 150%; /* 36px */
  letter-spacing: -0.48px;
`;

const SubTitle = styled.p`
  margin-bottom: 16px;
  color: var(--KTP-Grayscale-50, var(--KTP-Color-Mono-50, #80848a));
  font-size: 14px;
  font-weight: 500;
  line-height: 150%; /* 21px */
  letter-spacing: -0.28px;
`;

const DevideLine = styled.div`
  background-color: #f5f6f7;
  width: 100%;
  height: 6px;
  margin: 24px 0;
`;

const ReceiptWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 0 20px 40px;
`;
